import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PageService} from '../../../page/services/page.service';

@Component({
  selector: 'app-multiple-search-matricula-modal',
  templateUrl: './multiple-search-matricula-modal.component.html',
  styleUrls: ['./multiple-search-matricula-modal.component.css']
})
export class MultipleSearchMatriculaModalComponent implements OnInit {

  matricula = '' ;
  matriculas: string [] = [];

  constructor(public dialogRef: MatDialogRef<MultipleSearchMatriculaModalComponent>,
              private pageService: PageService,  @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  addToMatricularToList(): void {

    this.matriculas.push(this.matricula.toUpperCase());
    this.matricula = '';
  }

  removeFromList(i: number): void {
    this.matriculas.splice(i, 1);
  }

}
